export const EXSBPRICETYPE_SHOW_RESET = 'EXSBPRICETYPE_SHOW_RESET'
export const EXSBPRICETYPE_SHOW_SET_ERROR = 'EXSBPRICETYPE_SHOW_SET_ERROR'
export const EXSBPRICETYPE_SHOW_SET_RETRIEVED = 'EXSBPRICETYPE_SHOW_SET_RETRIEVED'
export const EXSBPRICETYPE_SHOW_TOGGLE_LOADING = 'EXSBPRICETYPE_SHOW_TOGGLE_LOADING'
